import React, {useContext} from "react";
import Img from "../../common/Img";
import MainButton from "../../common/MainButton";
import lbl from "../../../data/Labels.json";
import MainTitle from "../../common/MainTitle";
import {PopUpContext} from "../../../contexts/popUpContext";

const EducationalInfo = ({student, studentInfo, callback}) => {
    const {togglePopUp} = useContext(PopUpContext);

    return (
        <div className="student-info">
            <div className="main-content-header">
                <div className="left-content">
                    {studentInfo ? <MainButton
                        type="pen"
                        title={lbl.Edit}
                        handleClick={() => togglePopUp({
                            form: "student-educational-info-form",
                            edit: studentInfo,
                            student: student,
                            callback: callback,
                        })}
                    /> : ''}
                </div>
                <div className="right-content">
                    <MainTitle title="مشخصات تعلیمی"/>
                </div>
            </div>
            <div className="student-detail">
                <div className="detail_item">
                    <p>نام مکتب</p>
                    <p>{studentInfo?.school_name}</p>
                </div>
                <div className="detail_item">
                    <p>سال فراغت</p>
                    <p>{studentInfo?.graduation_year}</p>
                </div>
                <div className="detail_item">
                    <p>آیدی کانکور</p>
                    <p>{studentInfo?.gov_kankor_id}</p>
                </div>
                <div className="detail_item">
                    <p>سال اشتراک در کانکور</p>
                    <p>{studentInfo?.gov_kankor_year}</p>
                </div>
                <div className="detail_item">
                    <p>نمره کانکور ملی</p>
                    <p>{studentInfo?.gov_kankor_score}</p>
                </div>
                <div className="detail_item">
                    <p>نمره کانکور آریا</p>
                    <p>{studentInfo?.aria_kankor_score}</p>
                </div>
            </div>
        </div>
    );
};

export default EducationalInfo;
